<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert' }]" />

    <field-workplace-table-employee :readonly="board.readonly" :isPrint="isPrint" v-model="form.infoDatas" @input="inputField" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTableEmployee from "@/components/FieldWorkplaceTableEmployee.vue";

export default {
  components: {
    FieldWorkplaceTableEmployee,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        infoDatas: [],
        field_names: "",
      },
    };
  },
  methods: {
    inputField(value) {
      this.form.field_names = "";
      for (const data of value) {
        if (!this.form.field_names.includes(data.field_name) && data.field_name !== undefined) {
          this.form.field_names += data.field_name + ",";
        }
      }
      if (this.form.field_names.length > 0) {
        this.form.field_names = this.form.field_names.slice(0, -1);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
